import studentCenter from '@/views/Warrant/studentCenter/index.vue'
import productCenter from '@/views/Warrant/productCenter/index.vue'
import shareProduct from '@/views/Warrant/shareProduct/index.vue'
import orderCenter from '@/views/Warrant/orderCenter/index.vue'
import writeoffCenter from '@/views/Warrant/writeoffCenter/index.vue'

export default [
  {
    path: '/Warrant/studentCenter',
    component: studentCenter,
    meta: { title: '学员中心' }
  },
  {
    path: '/Warrant/productCenter/',
    component: productCenter,
    meta: { title: '产品中心' }
  },
  {
    path: '/Warrant/shareProduct',
    component: shareProduct,
    props: { mode: 'share' },
    meta: { title: '分享产品' }
  },
  {
    path: '/Warrant/masterProduct',
    component: shareProduct,
    props: { mode: 'master' },
    meta: { title: '主理产品' }
  },
  {
    path: '/Warrant/allyProduct',
    component: shareProduct,
    props: { mode: 'ally' },
    meta: { title: '合作产品' }
  },
  {
    path: '/Warrant/orderCenter',
    component: orderCenter,
    meta: { title: '订单中心' }
  },
  {
    path: '/Warrant/writeoffCenter',
    component: writeoffCenter,
    meta: { title: '核销中心' }
  },
]
